import ListMasterConcept from './views/List.vue'
import CreateEditMasterConcept from './views/CreateEdit.vue'
import GetMasterConcept from './views/Get.vue'

export const MasterConceptRoutes = [
  {
    path: '/master-concepts',
    name: 'ListMasterConcepts',
    component: ListMasterConcept,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'master_concept:list'
    }
  },
  {
    path: '/master-concept',
    name: 'CreateMasterConcept',
    component: CreateEditMasterConcept,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'master_concept:create'
    }
  },
  {
    path: '/master-concept/:id',
    name: 'UpdateMasterConcept',
    component: CreateEditMasterConcept,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'master_concept:update'
    }
  },
  {
    path: '/master-concept/view/:id',
    name: 'GetMasterConcept',
    component: GetMasterConcept,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'master_concept:get'
    }
  }
]
